// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles for the toast notification */
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px; /* Space between toasts */
}

.toast {
  min-width: 300px;
  max-width: 400px;
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 14px;
  color: #fff;
  transition: opacity 0.5s ease-out, transform 0.5s ease-out;
}

.toast.fadeIn {
  animation: fadeIn 0.5s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 0.95;
    transform: translateY(0);
  }
}


/* Close button styles */
.toast-close-btn {
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  transition: transform 0.2s ease;
}

.toast-close-btn:hover {
  transform: scale(1.2);
}

/* Variant styles */
.toast-success {
  background-color: #28a745;
}

.toast-error {
  background-color: #dc3545;
}

.toast-warning {
  background-color: #ffc107;
  color: #000; /* Black text for contrast */
}

.toast-info {
  background-color: #17a2b8;
}

/* Icon styles */
.toast > div > svg {
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/notification.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,yBAAyB;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,WAAW;EACX,0DAA0D;AAC5D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,aAAa;IACb,wBAAwB;EAC1B;AACF;;;AAGA,wBAAwB;AACxB;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW,EAAE,4BAA4B;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,eAAe;AACjB","sourcesContent":["/* Base styles for the toast notification */\n.toast-container {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px; /* Space between toasts */\n}\n\n.toast {\n  min-width: 300px;\n  max-width: 400px;\n  padding: 15px 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  font-size: 14px;\n  color: #fff;\n  transition: opacity 0.5s ease-out, transform 0.5s ease-out;\n}\n\n.toast.fadeIn {\n  animation: fadeIn 0.5s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 0.95;\n    transform: translateY(0);\n  }\n}\n\n\n/* Close button styles */\n.toast-close-btn {\n  background: transparent;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  font-size: 16px;\n  transition: transform 0.2s ease;\n}\n\n.toast-close-btn:hover {\n  transform: scale(1.2);\n}\n\n/* Variant styles */\n.toast-success {\n  background-color: #28a745;\n}\n\n.toast-error {\n  background-color: #dc3545;\n}\n\n.toast-warning {\n  background-color: #ffc107;\n  color: #000; /* Black text for contrast */\n}\n\n.toast-info {\n  background-color: #17a2b8;\n}\n\n/* Icon styles */\n.toast > div > svg {\n  font-size: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
